import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../Header';
import Header2 from '../Header2';
import Footer from '../Footer';
import './Merchandise.css';

const DESKTOP_BREAKPOINT = 900;

export default function Merchandise() {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const check = () => setIsDesktop(window.innerWidth >= DESKTOP_BREAKPOINT);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  return (
    <div className="merch-root">
      <Header />
      {isDesktop && <Header2 />}

      <section className="merch-hero">
        <span className="merch-eyebrow">StarView Merchandise</span>
        <h1 className="merch-title">The Shop Is Coming Soon</h1>
        <p className="merch-subtitle">
          Popcorn buckets, apparel, collectibles — and real live auctions for limited-run pieces.
          We're building it for real, not a placeholder gallery. Check back soon.
        </p>
        <div className="merch-cta-row">
          <Link to="/GiftCards" className="merch-cta">Send a Gift Card Instead</Link>
          <Link to="/Showtimes" className="merch-cta merch-cta-secondary">Browse Showtimes</Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
